import { PUBLIC_POSTHOG_TOKEN } from '$env/static/public';
import posthog from 'posthog-js';

import { dev } from '$app/environment';

import { analytics } from '$lib/analytics';

export function initAnalytics() {
	if (dev) {
		return;
	}

	posthog.init(PUBLIC_POSTHOG_TOKEN, {
		api_host: 'https://eu.i.posthog.com',
		person_profiles: 'identified_only',
		session_recording: {
			maskTextSelector: '*'
		},

		loaded(instance) {
			globalThis.window.posthog = instance;
		}
	});

	analytics.setClient({
		capture(data) {
			const eventName = `${data.category}:${data.target}_${data.verb}`;
			posthog.capture(eventName, data.data);
		}
	});
}
